import DomUtils from "./DomUtils";
import Gpt from "./Gpt";

const handleAdVisible = (entries, observer) => {
  const renderAd = ({ isIntersecting, target }) => {
    if (target && target.id) {
      return;
    }

    if (isIntersecting) {
      DomUtils.setId(target);
      const id = DomUtils.getId(target);
      Gpt.displayAd(id);

      observer.unobserve(target);
    }
  };

  entries.map(renderAd);
};

const startObservers = () => {
  const targets = DomUtils.lazyAdContainers();
  const config = {
    root: null,
    rootMargin: "150px 0px 0px 0px"
  };

  const observer = new IntersectionObserver(handleAdVisible, config);

  const observeTarget = target => {
    observer.observe(target);
  };

  targets.map(observeTarget);
};

export default Object.freeze({ startObservers });
